(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[action="/contact"]');

    if (!form) return;

    form.addEventListener('submit', function (e) {
      // If browser validation fails
      if (!form.checkValidity()) {
        e.preventDefault();
        form.reportValidity();
        return;
      }
    });

    // Optional: smooth scroll to messages after reload
    const message = document.querySelector('.form-message');
    if (message) {
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
